import { render, staticRenderFns } from "./ChatRichComposerDialog.vue?vue&type=template&id=312dac50&scoped=true"
import script from "./ChatRichComposerDialog.vue?vue&type=script&lang=js"
export * from "./ChatRichComposerDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatRichComposerDialog.vue?vue&type=style&index=0&id=312dac50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dac50",
  null
  
)

export default component.exports